import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../api/client';
import './StaffProfiles.css';

export interface StaffProfile { aboutMe: string; photoUrl: string | null }
export interface StaffPerson extends Partial<StaffProfile> { _id: string | number; name: string }

function Avatar({ person }: { person: Pick<StaffPerson, 'name' | 'photoUrl'> }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return person.photoUrl && failedUrl !== person.photoUrl
    ? <img className="staff-avatar" src={`${getApiBaseUrl()}${person.photoUrl}`} alt="" loading="lazy" onError={() => setFailedUrl(person.photoUrl!)} />
    : <span className="staff-avatar staff-avatar--initials" aria-hidden="true">{person.name.trim().split(/\s+/).slice(0, 2).map(word => word[0]).join('')}</span>;
}

/** Inline disclosures preserve the current activity/event and keyboard focus. */
export default function StaffProfiles({ people = [] }: { people?: StaffPerson[] }) {
  const { t } = useTranslation();
  if (!people.length) return null;
  return <div className="staff-profiles" onClick={event => event.stopPropagation()} onKeyDown={event => event.stopPropagation()}>
    {people.map(person => <details className="staff-profile" key={person._id}>
      <summary><Avatar person={person} /><span>{person.name}</span><span className="staff-profile__expand" aria-hidden="true">⌄</span></summary>
      <div className="staff-profile__bio"><strong>{t('staffProfile.aboutMe')}</strong><p>{person.aboutMe || t('staffProfile.noBio')}</p></div>
    </details>)}
  </div>;
}

export { Avatar };
